import SecondaryText from "../../../components/general/BaseOutlineText";
import { baseQuoteParseOptions } from "../../../components/general/BaseQuote";
import BaseRevealText from "../../../components/general/BaseRevealText";

type VisionType = {
  vision: string
}

function Vision(props: VisionType) {

  return (

    <BaseRevealText
      text={props.vision}
      parseOptions={baseQuoteParseOptions}
      topContent={
        <SecondaryText
          text="Vision"
          textSize="text-8xl sm:text-[10rem]"
          weight="medium"
          classProps="opacity-50 -mb-32"
        />
      }
    />
  );
}

export default Vision;
